/* eslint-disable jsx-a11y/label-has-associated-control */
import { Dialog, Transition } from '@headlessui/react';
import React, { useContext } from 'react';
import { ModalType } from '@models/pages';
import { GlobalContext } from '../GlobalContext';
import SocialShare from '../SocialShare';

type Props = {
  href: string
  lang: string
  stringTranslations: any
}
function SocialShareModal({ href, lang, stringTranslations } :Props) {
  const globalContext = useContext(GlobalContext);

  const isModalOpen = () => {
    if (globalContext) {
      const { showModal } = globalContext;
      return showModal === ModalType.SocialShare;
    }

    return false;
  };

  const handleClose = () => {
    if (globalContext) {
      const { setShowModal } = globalContext;
      setShowModal('');
    }
  };

  return (
    <Transition appear show={isModalOpen()} as={React.Fragment}>
      <Dialog
        as="div"
        className="relative z-40"
        onClose={handleClose}
      >
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-40" />
        </Transition.Child>
        <div className="fixed inset-0 overflow-y-auto article">
          <div className="flex items-center justify-center min-h-full text-center">
            <Dialog.Panel className="bg-white mx-auto max-w-[32rem] min-h-[260px] shadow-xl transform transition-all text-left w-full lg:w-[75%]">
              <div className="m-6">
                <SocialShare
                  lang={lang}
                  href={href}
                  stringTranslations={stringTranslations}
                />
              </div>
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default SocialShareModal;
